<template>
  <div class="player-demo">
    <div class="main-content">
      <div class="m-left">
        <div class="player-olympic" ref="playerTemp" @click="videoBarChange"></div>
        <!-- <watermark v-if="moveRange" :position="moveRange" ></watermark> -->
      </div>
    </div>
  </div>
</template>

<script>
import playerFullScreenTitle from "components/MyAliplayer/playerFullScreenTitle";
import playerTipComponent from "components/MyAliplayer/playerTipComponent";
import RateComponent from "components/MyAliplayer/RateComponent";
// import watermark from "components/MyAliplayer/shuiyin";
import mixin from '@/views/column_video/mixins'

export default {
  props: {
    video1: {
      type: Object,
      default: () => ({})
    },
    videoHeight: {
      type: String
    },
    videoDetail: {
      type: String
    },
    video_id: {
      type: String
    },
    column_id: {
      type: String
    }
  },
  mixins: [mixin],
  // components: {
  //   watermark
  // },
  data() {
    return {
      player: null,
      videoUrl: "",
      // moveRange: ""
      localData: {},
      seeked: false,
      // 控制栏限制状态
      videoBarSatet: true,
    };
  },
  mounted() {
    var _this = this;
    setTimeout(() => {
      _this.$nextTick(() => {
        var hash = "";
        hash = _this.videoDetail.split(".")[0] + ".m3u8";
        _this.videoUrl =
          document.location.origin +
          "/index.php/mobile/file/media?hash=" +
          hash +
          "&user_id=" +
          localStorage.getItem("_user_data_id") +
          "&company_id=" +
          localStorage.getItem("_user_data_company_id") +
          "&sso_token=" +
          localStorage.getItem("_user_data_sso_token") +
          "&sys_id=5&language=" +
          localStorage.getItem("_user_data_language");
        _this.createDemoPlayer(_this.videoUrl);
        // var ali_video = $("video")[0];
        // ali_video.addEventListener("play", () => {
        //   $(".prism-player .prism-controlbar").css(
        //     "visibility",
        //     "visible !important"
        //   );
        // });
        // ali_video.addEventListener("ended", () => {
        //   ali_video.play();
        // });
        // _this.init();
      });
    }, 0);
    // 判断当前页面是否被激活或浏览器进入后台运行
    window.onblur = () => {
      if(this.player) this.player.pause()
    }
    document.addEventListener("visibilitychange", () => {
        if (document.hidden && this.player) {
          this.player.pause()
        }
    })
  },
  methods: {
    videoBarChange() {
      if(this.player) {
        this.videoBarSatet = !this.videoBarSatet
        if(this.videoBarSatet) {
          $('#player-con .prism-controlbar').show();
          this.player.trigger('showBar')
        } else {
          $('#player-con .prism-controlbar').hide();
          this.player.trigger('hideBar')
        }
      }
    },
    createDemoPlayer(source) {
      if (document.getElementById("player-con") === null) {
        let playerDomWrap = this.$refs.playerTemp;
        let playerDom = document.createElement("div");
        playerDom.setAttribute("id", "player-con");
        playerDomWrap.appendChild(playerDom);
      }

      let props = {
        id: "player-con",
        width: "100%",
        autoplay: true,
        rePlay: true,
        playsinline: true, //H5是否内置播放
        useH5Prism: true, //强制H5播放器
        controlBarVisibility: "always", //控制面板的实现 ‘click’ 点击出现、‘hover’ 浮动出现、‘always’ 一直在
        language: "zh-cn",
        source: source,
        isLive: false,
        components: [
          {
            name: "playerFullScreenTitle",
            type: playerFullScreenTitle
          },
          {
            name: "playerTipComponent",
            type: playerTipComponent
          },
          {
            name: "RateComponent",
            type: RateComponent
          }
        ]
        // skinLayout: [{ name: "volume",  }]
      };
      if (this.videoHeight) {
        props.height = this.videoHeight;
      }
      // var player = new Aliplayer(props, function(player) {
      //   player.play();
      // });
      this.player = new Aliplayer(props);

      // this.player.on("requestFullScreen", this.fullScreenHandle);
      // this.player.on("cancelFullScreen", this.cancelFullScreenHandel);
      this.player.on("play", this.play);
      this.player.on("pause", this.playerPause);
      this.player.on("timeupdate", this.update);
      this.player.on("canplaythrough", this.canplaythrough);
      $('.prism-controlbar').on("click", (event) => {
        $('#player-con .prism-controlbar').show();
        this.player.trigger('showBar')
        event.stopPropagation();
      });
      // this.player.on("ended", this.ended);
    },
    canplaythrough() {
      // console.log(this.seeked);
      if (!this.seeked) {
        this.seeked = true;
        if (
          localStorage.getItem(
            "audio_" + this.column_id + "_" + this.video_id
          ) != null
        ) {
          if (
            JSON.parse(
              localStorage.getItem(
                "audio_" + this.column_id + "_" + this.video_id
              )
            ).currentTime != -1
          ) {
            var time = JSON.parse(
              localStorage.getItem(
                "audio_" + this.column_id + "_" + this.video_id
              )
            ).currentTime;
            this.player.seek(time);
          } else {
            this.player.seek(0);
          }
        } else {
          this.player.seek(0);
        }
      }
    },
    // fullScreenHandle() {
    //   this.player.getComponent("playerFullScreenTitle").fullScreenHandle("");
    //   this.fullScreen = true;
    // },
    // cancelFullScreenHandel() {
    //   this.player
    //     .getComponent("playerFullScreenTitle")
    //     .cancelFullScreenHandle();
    //   this.fullScreen = false;
    // }

    play() {
      $(".prism-player .prism-controlbar").css(
        "visibility",
        "visible !important"
      );
      if(this.startSeekTime == null) {
        this.seekTimer = 0;
        this.startSeekTime = Date.parse(new Date())/1000
      }
      this.timerFun()
    },
    update() {
      // var time = this.player.getCurrentTime();
      this.localData.currentTime = this.player.getCurrentTime();
      localStorage.setItem(
        "audio_" + this.column_id + "_" + this.video_id,
        JSON.stringify(this.localData)
      );
    },
    // 视频暂停
    playerPause() {
      this.clearTimer();
      if(this.seekTimer > 0) {
        this.submitStudyTime(this.video_id);
      }
    }
  },
  beforeDestroy () {
    this.startSeekTime == null
  },
  deactivated () {
    this.startSeekTime == null
  }
};
</script>


<style lang="less">
@import "./index.less";
// @import url("https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css");

// .player-demo3 {
//   .main-content {
//     .m-left {
//       position: relative;
//       .player-olympic {
//         .prism-progress-cursor {
//           display: none !important;
//         }
//         .prism-player video {
//           height: 99% !important;
//         }
//         .prism-player .prism-big-play-btn {
//           top: 50% !important;
//           left: 50% !important;
//           margin-top: -0.5rem;
//           margin-left: -0.5rem;
//           // width: 1rem;
//           // height: 1rem;
//           // z-index: 999999999;
//         }
//         .prism-player .prism-big-play-btn .outter {
//           // width: 1rem;
//           // height: 1rem;
//         }
//         .prism-player .prism-loading {
//            top: 50% !important;
//           left: 50% !important;
//           // width: 0.6rem;
//           // height: 0.6rem;
//         }
//         .prism-player .prism-loading .circle {
//           // width: 0.6rem;
//           // height: 0.6rem;
//         }
//         .prism-player .prism-volume {
//           display: none !important;
//         }
//         .prism-player .prism-cc-btn {
//           display: none !important;
//         }
//         .prism-player .prism-setting-btn {
//           display: none;
//         }
//         .prism-player .prism-cover {
//           background-repeat: no-repeat;
//           z-index: 0;
//         }
//         .prism-player .prism-controlbar .prism-controlbar-bg {
//           // height: 0.8rem;
//         }
//         .prism-player .prism-controlbar {
//           visibility: hidden;
//           // height: 0.8rem;
//         }
//         .prism-player .prism-liveshift-progress,
//         .prism-player .prism-progress {
//           // bottom: 0.8rem !important;
//         }
//         .prism-player .prism-play-btn {
//           // width: 0.48rem;
//           // height: 0.48rem;
//           // margin-top: 0.16rem !important;
//         }
//         .prism-player .prism-pause-animation {
//           background: url("../../assets/img/learning_camp/playanimation.png")
//             no-repeat;
//           background-size: 100%;
//         }
//         .prism-player .prism-play-btn:hover {
//           background: url("../../assets/img/learning_camp/smallplay.png")
//             no-repeat;
//           background-size: 100%;
//         }
//         .prism-player .prism-play-animation {
//           background: url("../../assets/img/learning_camp/pauseanimation.png")
//             no-repeat;
//           background-size: 100%;
//         }
//         .prism-player .prism-play-btn.playing:hover {
//           background: url("../../assets/img/learning_camp/smallpause.png")
//             no-repeat;
//           background-size: 100%;
//         }
//         .prism-player .prism-time-display {
//           // height: 0.8rem;
//           // line-height: 0.8rem;
//           // margin-top: 0rem !important;
//           // margin-left: 0.2rem !important;
//           // font-size: 0.26rem;
//         }
//         .prism-player .prism-fullscreen-btn {
//           // width: 0.48rem;
//           // height: 0.48rem;
//           // margin-top: 0.16rem !important;
//         }
//         // .current-rate {
//         //   font-size: 0.26rem;
//         // }
//       }
//     }
//   }
// }
</style>



